import { useQuery } from '@tanstack/react-query';
import { api } from '../../../../singleton/axios';

export interface RevenueProductSegmentation {
  symbol: string;
  fiscalYear: number;
  period: string; // "FY", "Q1", "Q2", "Q3", "Q4"
  reportedCurrency: string | null;
  date: string;
  data: Record<string, number>; // Segment names → revenue values (fully dynamic, varies by company and period)
}

export const useCompanyRevenueProductSegmentation = (
  ticker: string | undefined,
  period?: 'annual' | 'quarter'
) => {
  return useQuery<RevenueProductSegmentation[], Error>({
    queryKey: ['companyRevenueProductSegmentation', ticker, period],
    queryFn: async () => {
      if (!ticker) throw new Error('Ticker is required');

      const params: Record<string, string> = { ticker };
      if (period) params.period = period;

      const { data } = await api.get<RevenueProductSegmentation[]>(
        '/company-revenue-product-segmentation',
        { params }
      );
      return data;
    },
    enabled: !!ticker,
    refetchOnWindowFocus: false,
    staleTime: 2.5 * 60 * 1000,
    retry: (failureCount, error) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if ((error as any)?.response?.status === 404) return false;
      return failureCount < 2;
    },
  });
};
